import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { cards as Cards } from '@breezeway/brzw-components';
import { DIMENSION_STATES } from '../../../utils/dimension';
import { getElementIcon } from '../../../../@datastore/selectors/index';
import { getWindowState } from '../../../../@shared/active_resize_listener/selectors';
import CardImagePathHelper from '../card_image_path_helper';

const Card = props => {
  const {
    className,
    editText,
    editTextClassName,
    editTextWrapperClassName,
    getIcon,
    icon,
    iconClassName,
    imageClassName,
    isSmall,
    onClick,
    photo,
    windowState,
  } = props;

  const isMobile = windowState === DIMENSION_STATES.MOBILE;
  const imageSrc = CardImagePathHelper(photo, isSmall, isMobile);

  return (
    <Cards.Card
      className={className}
      editText={editText}
      editTextClassName={editTextClassName}
      editTextWrapperClassName={editTextWrapperClassName}
      imageSrc={imageSrc}
      getIcon={getIcon}
      icon={icon}
      iconClassName={iconClassName}
      imageClassName={imageClassName}
      isMobile={isMobile}
      isSmall={isSmall}
      onClick={onClick}
      photo={photo}
      windowState={windowState}
    />
  );
};

Card.propTypes = {
  className: PropTypes.string,
  editText: PropTypes.string,
  editTextClassName: PropTypes.string,
  editTextWrapperClassName: PropTypes.string,
  getIcon: PropTypes.string,
  icon: PropTypes.string,
  iconClassName: PropTypes.string,
  imageClassName: PropTypes.string,
  isSmall: PropTypes.bool,
  onClick: PropTypes.func,
  photo: PropTypes.shape({
    bucket: PropTypes.string,
    height: PropTypes.number,
    photo_key: PropTypes.string,
    width: PropTypes.number,
  }),
  windowState: PropTypes.string,
};

const mapStateToProps = (state, ownProps) => ({
  getIcon: getElementIcon(state, ownProps.icon),
  windowState: getWindowState(state),
});

export default connect(mapStateToProps)(Card);
